import { mx } from './mx'
import { df } from './df'
import { ng } from './ng'
import { kn } from './kn'

export default {
    'default': df,
    'ipeso': mx,
    'xfectivo': mx,
    'xcredit': ng,
    'imoney': ng,
    'ipesa': kn,
    'kashway': kn,
}